export default {
  isActive: false,
  isActiveHorizontal: false,
  isActiveVertical: false,
  isActiveSecondary: [],
};
